module.exports = __webpack_public_path__ + "img/topview.db865414.jpg";